
import clamp from '../assets/lib/clamp'

export default {
  bind (el, { value }) {
    return clamp(el, { clamp: value })
  },
}
